// @flow
import React from 'react'
import classnames from 'classnames'

type PropsT = {
  className?: string,
  autoFocus?: boolean,
  label: string,
  input: any,
  meta: any,
  hideLabel: boolean,
  tabIndex?: number,
  children: React$Element<any>
}

const renderSelect = ({ className, input, label, hideLabel, tabIndex, meta: { touched, error }, children }: PropsT) => (
  <div className='InputContainer'>
    {label &&
      <label className={classnames('Label', {
        'Label--error': touched && error,
        'hide': hideLabel
      })} htmlFor={input.name}>
        {label}
      </label>
    }
    <select {...input} tabIndex={tabIndex} className={classnames(className, { 'Input--error': touched && error })}>
      {children}
    </select>
    {touched && error && <span className='Input__error'>{error}</span>}
  </div>
)

export default renderSelect
